import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function SupportImage({ image }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [visible, setVisible] = useState(!globalThis.IntersectionObserver);
  const container = useRef(null);
  const id = image?.id;
  useEffect(() => {
    if (!globalThis.IntersectionObserver || !container.current) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: "100px" });
    observer.observe(container.current);
    return () => observer.disconnect();
  }, [id]);
  useEffect(() => {
    if (!id || !visible) return;
    let active = true, objectUrl;
    setUrl(""); setError(false);
    api.get(`/chat/messages/${id}/image`, { responseType: "blob" }).then(({ data }) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(data); setUrl(objectUrl);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [id, attempt, visible]);
  if (!image) return null;
  return <div ref={container}>
    {error ? <button type="button" onClick={() => setAttempt((n) => n + 1)} className="text-xs underline">Image unavailable · retry</button>
      : url ? <button type="button" aria-label="View support image" onClick={() => setExpanded(true)} className="block mb-1"><img src={url} alt="Support attachment" className="max-h-48 max-w-full rounded-lg object-contain" /></button>
      : <p className="text-xs opacity-60">{visible ? "Loading image…" : "Image attachment"}</p>}
    <Dialog open={expanded} onOpenChange={setExpanded}><DialogContent className="bg-[#121721] border-slate-700 max-w-2xl"><DialogTitle>Support image</DialogTitle><DialogDescription className="sr-only">An image shared in your private support conversation.</DialogDescription><img src={url} alt="Full-size support attachment" className="max-h-[75vh] w-full object-contain" /></DialogContent></Dialog>
  </div>;
}
